import { Wrap, WrapProps } from "@chakra-ui/react";

export function AppTilesWrapper({ children, ...rest }: WrapProps) {
  // As of now the only thing the wrapper does is to apply Wrap, so that the
  // tiles wrap around if there is not enough horizontal space.
  return <Wrap {...rest}>{children}</Wrap>;
}
